import styled from 'styled-components/macro';
import { Button } from '../../components/UI';

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.padding * 2}px;
`;

export const FileUploadSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({ theme }) => theme.padding}px 0;
`;

export const FileUploadPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 8rem;
  width: 12rem;
  margin-right: ${({ theme }) => theme.padding * 2}px;
  border-radius: 10px;
  border: dashed 1px rgba(101, 140, 215, 0.5);
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #658cd7;
    background-color: #f0f4ff;
  }
`;

export const FileUploadIcon = styled.div`
  width: 3rem;
  height: 3rem;
  background-color: #658cd7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const FileUploadText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileUploadTitle = styled.h4`
  color: ${({ theme }) => theme.primary.dark};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: 1.4rem;
  line-height: 2.4rem;
  margin: 0 0 0.5rem 0;
`;

export const FileUploadNote = styled.p`
  color: #366696;
  font-style: italic;
  font-size: 1.2rem;
  font-weight: ${({ theme }) => theme.fontWeights.light};
  opacity: 0.7;
  margin: 0;
`;

export const FileUploadButton = styled(Button)`
  margin-top: ${({ theme }) => theme.padding}px;
  max-width: 12.5rem;
  height: 5rem;
  border: 1px #75dbff solid;
  color: #658cd7;
  font-size: 1.2rem;
  font-weight: ${({ theme }) => theme.fontWeights.light};
  padding-left: 4rem;
  padding-right: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: unset;
`;

export const SelectedFileInfo = styled.div`
  margin-top: ${({ theme }) => theme.padding}px;
  padding: ${({ theme }) => theme.padding}px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-left: 3px solid #658cd7;
`;

export const SelectedFileName = styled.span`
  color: #366696;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 1.3rem;
`;

export const FormSection = styled.div`
  margin-bottom: ${({ theme }) => theme.padding * 2}px;
`;

export const FormSectionTitle = styled.h4`
  color: ${({ theme }) => theme.primary.dark};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.padding * 1.5}px;
  font-size: 1.6rem;
`;

export const InputGroup = styled.div`
  padding: ${({ theme }) => theme.padding}px 0;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.padding * 4}px;
`;

export const FileData = styled.div`
  margin: ${({ theme }) => theme.padding * 2}px 0;
  padding: ${({ theme }) => theme.padding * 2}px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #658cd7;
`; 